export default {
  conciergeActivatedTrail: state => state.activeTrail,
  getEvents: state => state.eventsList && state.eventsList.data,
  getMembers: state => state.userList.data,
  getOrdersStore: state => state.orders,
  getOrdersStatus: state => state.orders && state.orders.status,
  getOptions: state => state.optionsList.data,
  getFilters: state => state.filters,
  getReportHistory: state => state.reportHistory,
  getStripeCheckout: state => state.stripeCheckout
};
